import React from 'react'

import { isNil } from 'ramda'

import { Link, Text } from '@driftt/dds'

export const TeammatesTableDrilldownLink = ({
  column,
  value,
  onClick = () => null,
  format = (value) => value?.toString(),
}: {
  column: string
  value: string | number
  onClick?: () => void
  format?: (value: string | number) => string
}) => {
  const isNilValue = isNil(value)
  const isZero = Number(value) === 0

  if (isNilValue || isZero) {
    return <Text>{format(value)}</Text>
  }

  return (
    <Link
      variant="inline"
      target="__blank"
      data-track={`drilldown-btn-${column}`}
      onClick={onClick}
      underline
    >
      {format(value)}
    </Link>
  )
}
